export const inputPlaceholders = {
    lastName: 'IVANOV',
    firstName: 'IVAN',
    birthday: 'Дата рождения',
};
export const inputLabels = {
    lastName: 'Фамилия',
    firstName: 'Имя',
    birthday: 'Дата рождения',
};
export const inputNames = {
    lastName: 'lastname',
    firstName: 'firstname',
    birthday: 'birthday',
};
